"use client";

import React from "react";
import { HoldingChangeTable } from "@/src/components/WhaleHoldings/WhaleHoldingsDetail/HoldingChangeTable";
import { ROUTER_PATH } from "@/src/config/router";
import { ViewDetailsLink } from "./ViewDetailsLink";

interface WhaleHoldingChangeBusinessChartProps {
  cikId: string;
}

export const WhaleHoldingChangeBusinessChart: React.FC<
  WhaleHoldingChangeBusinessChartProps
> = ({ cikId }) => {
  return (
    <>
      <div className="w-full overflow-hidden">
        <HoldingChangeTable cikId={cikId} />
      </div>
      <ViewDetailsLink
        href={`${ROUTER_PATH.WHALE_HOLDINGS}/${encodeURIComponent(cikId)}`}
      />
    </>
  );
};
